import React from "react";

export default function How() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-extrabold text-slate-900 sm:text-4xl">
            How to File a Report
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Please ensure you meet the reporting criteria before starting your application.
          </p>
        </div>

        {/* Prerequisites Checklist Card */}
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8 mb-16">
          <h3 className="text-xl font-bold text-slate-800 mb-5 border-b border-gray-100 pb-3">
            Eligibility Checklist
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 text-gray-700 font-medium">
            <li className="flex items-start">
              <svg className="w-6 h-6 text-green-500 mr-3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
              Vehicle was stolen between Jan 2018 and Dec 2022.
            </li>
            <li className="flex items-start">
              <svg className="w-6 h-6 text-green-500 mr-3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
              Theft was officially reported to an NPF Division or Station.
            </li>
            <li className="flex items-start">
              <svg className="w-6 h-6 text-red-500 mr-3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
              If not reported, visit a Police Station before continuing.
            </li>
            <li className="flex items-start">
              <svg className="w-6 h-6 text-green-500 mr-3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
              The vehicle is currently unrecovered.
            </li>
          </ul>
        </div>

        {/* 3-Step Process Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Step 1 */}
          <div className="bg-white rounded-xl shadow-md p-8 relative overflow-hidden group hover:-translate-y-1 transition-transform border border-gray-100">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-6xl font-black text-blue-100/50 group-hover:scale-110 transition-transform">1</div>
            <h4 className="text-xl font-bold text-slate-900 mb-3 relative z-10">Create Profile</h4>
            <p className="text-gray-600 relative z-10 leading-relaxed">Click "Get Started" to register securely on the platform and set up your user profile.</p>
          </div>
          
          {/* Step 2 */}
          <div className="bg-white rounded-xl shadow-md p-8 relative overflow-hidden group hover:-translate-y-1 transition-transform border border-gray-100">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-6xl font-black text-blue-100/50 group-hover:scale-110 transition-transform">2</div>
            <h4 className="text-xl font-bold text-slate-900 mb-3 relative z-10">Select Location</h4>
            <p className="text-gray-600 relative z-10 leading-relaxed">Enter your current State and Local Government Area (LGA) of residence.</p>
          </div>
          
          {/* Step 3 */}
          <div className="bg-white rounded-xl shadow-md p-8 relative overflow-hidden group hover:-translate-y-1 transition-transform border border-gray-100">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-6xl font-black text-blue-100/50 group-hover:scale-110 transition-transform">3</div>
            <h4 className="text-xl font-bold text-slate-900 mb-3 relative z-10">Submit Details</h4>
            <p className="text-gray-600 relative z-10 leading-relaxed">Provide the required identifying information about the stolen vehicle and submit.</p>
          </div>
        </div>
      </div>
    </section>
  );
}